import React from 'react';

import {
  TableColumns,
  Column,
  FullColumnName,
  TableName,
} from '@models/column';
import { isSet, Unset } from '@utils';
import { ColumnWidget } from './ColumnField';
import { TableWidget } from './TableField';
import { Widget, InlineEditorProps, InlineEditor } from './_InlineDraftEditor';

export const TableColumnWidget = (
  props: {
    tableColumns: TableColumns;
  } & Widget<Partial<Column> | Unset, Partial<Column>>
) => {
  const columns = getAdtColumns(props.tableColumns, props.value?.table);
  const tables = Object.keys(props.tableColumns);

  return (
    <div style={{ display: 'flex', gap: '4px' }}>
      <TableWidget
        tables={tables}
        value={props.value?.table}
        onValueChange={table => {
          props.onValueChange({ table });
        }}
      />

      <ColumnWidget
        columns={columns}
        value={props.value?.name}
        onBlur={props.onBlur}
        onValueChange={props.onValueChange}
      />
    </div>
  );
};

export const TableColumnInlineEditor = (
  props: InlineEditorProps<Column> & { tableColumns: TableColumns }
) => {
  return (
    <InlineEditor
      {...props}
      widget={TableColumnWidget}
      widgetProps={{ tableColumns: props.tableColumns }}
      prettifyFn={column => FullColumnName.create(column)}
    />
  );
};

function getAdtColumns(
  tableColumns: TableColumns,
  tableName: TableName | Unset
): Column[] {
  return isSet(tableName) ? tableColumns[tableName] ?? [] : [];
}
